import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/API/api.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  aboutContent: any;
  aboutImage: any;
  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.lodadAboutContent();
  }

  lodadAboutContent(){
    this.apiService.vendorSettings().subscribe({
      next: response => {
        this.aboutContent = response.settings.about_us;
        this.aboutImage = response.settings.about_us_img;
      }, 
      error: (error: any) => {
        console.log(error);
      }
    });
  }
}
